import React from "react";
import OfficerLogin from "../components/auth/login/OfficerLogin";

const Office = () => {
  return <OfficerLogin />;
};

export default Office;
